module.exports = __webpack_public_path__ + "img/tool_icon_5.63b49c9.png";